export default __webpack_public_path__ + "static/media/section-2.eccb99e9.png";